import { ButtonGroup, GroupButton } from 'ui/buttonGroup';

type Props = {
  /** Default page size selected */
  defaultSize?: number;
  /** Array of page sizes to use */
  pageSizes: number[];
  /** Function to run when a page size is selected. */
  onSelect: (val: number) => void;
  /** Total number of elements */
  total: number;
};

export const PageSize = ({ defaultSize, onSelect, pageSizes, total, ...props }: Props) => {
  const sortedPageSizes = pageSizes.sort((p1, p2) => p1 - p2);

  // filter out page size buttons that are needlessly big
  const firstAllIncludedSize = pageSizes.findIndex((size) => size >= total);
  const usedSizes =
    firstAllIncludedSize > -1
      ? sortedPageSizes.slice(0, firstAllIncludedSize + 1)
      : sortedPageSizes;

  /**
    make sure the default is included, otherwise default to the smallest option
  */
  const safeDefaultSize =
    defaultSize !== undefined && usedSizes.includes(defaultSize) ? defaultSize : usedSizes[0];

  // single button displays are disabled since it's useless
  const isDisabled = usedSizes.length === 1;

  return (
    <ButtonGroup
      data-test="page-size-buttons"
      defaultSelectedId={`opt-${safeDefaultSize}`}
      id="page-size-controls"
      trackSelected
      {...props}
    >
      {usedSizes.map((size) => (
        <GroupButton
          isDisabled={isDisabled}
          key={`opt-${size}`}
          id={`opt-${size}`}
          onSelect={() => onSelect(size)}
        >
          {size}
        </GroupButton>
      ))}
    </ButtonGroup>
  );
};

export default PageSize;
